var map = {
	"./fraunces-v31-latin-600.woff2": "./fonts/fraunces-v31-latin-600.woff2",
	"./fraunces-v31-latin-regular.woff2": "./fonts/fraunces-v31-latin-regular.woff2",
	"./fraunces.woff2": "./fonts/fraunces.woff2",
	"./poppins-v21-latin-500.woff2": "./fonts/poppins-v21-latin-500.woff2",
	"./poppins-v21-latin-600.woff2": "./fonts/poppins-v21-latin-600.woff2",
	"./poppins-v21-latin-700.woff2": "./fonts/poppins-v21-latin-700.woff2",
	"./poppins-v21-latin-regular.woff2": "./fonts/poppins-v21-latin-regular.woff2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./fonts sync recursive ^\\.\\/.*$";